import { Fragment } from 'react';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

class Gas extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			editable: props.editable,
			gas: {
				GAS_ID: ''
			},
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadGas();
	}

	loadGas(event) {
		var self = this;
		
		if (this.props.params.gasId) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/HeLAD/Search',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					context: 'DEMURRAGE',
					entity: 'DEM_GASES',
					search: { Attribute: 'GAS_ID', Operator: '=', LongValue: this.props.params.gasId },
					pageNumber: -1,
					pageSize: -1
				}
			}).done(function (data) {
				if (data.Success) {
					if (data.Data.length > 0) {
						var gas = data.Data[0];
						self.mvc2js(gas, gasColumns);
						
						gas.CREATED = self.composeChangeInfo(gas.CREATED_BY, gas.CREATED_DATE);
						gas.MODIFIED = self.composeChangeInfo(gas.MODIF_BY, gas.MODIF_DATE);
							
						self.mergeState({
							gas: gas,
							renderKey: self.state.renderKey + 1
						}, () => {
							if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
						});
					} else {
						self.showAlert('Gas Error', data.Data.length + ' Gases found for ID ' + self.props.params.gasId);
					}
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});	
		} else {
			this.mergeState({
				gas: {
					GAS_ID: '(new)',
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}
		
	onChange(accessor, value) {
		var gas = this.copyObject(this.state.gas);
		this.setByAccessor(gas, accessor, value);
		this.mergeState({ gas: gas, renderKey: this.state.renderKey + 1 });
	}
		
	deleteGas(event) {
		var self = this;
		
		this.showOKCancel('Confirm Delete Gas', 'Delete Gas ' + this.props.params.gasId + '?', (okClicked) => {
			if (okClicked) {
				// prepare gas for deletion		
				var gas = {
					GAS_ID: self.props.params.gasId,
					DELETE_FLAG: 'Y',
					MODIF_BY: self.props.user.name,
					MODIF_DATE: self.dateTimeToMVC(new Date())
				};
				
				this.ajax({
					type: 'POST',
					url: self.getConfig().host + '/Home/Update',
					data: { __RequestVerificationToken: self.props.user.antiForgeryToken, entity: 'DEMURRAGE.DEM_GASES', data: gas }
				}).done(function (data) {
					if (data.Success) {
						self.props.parent.showConfirmation(() => {
							return (<>
								Gas {self.props.params.gasId} deleted.
							</>); 
						});
					} else {
						self.showAlert('Server Error', data.Message);
					}			
				}).fail(function (jqXHR, textStatus, errorThrown) {
					self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
				});
			}
		});
	}

	onSubmit(event) {
		var self = this;
		var url;
		
		// make copy of data
		var gas = this.copyObject(this.state.gas);
		this.js2mvc(gas, gasColumns);
		
		// if this is a new gas
		if (!this.props.params.gasId) {
			// set ID to sequence name
			url = '/Home/Insert';
			gas.GAS_ID = 'dem_gas_seq.nextval';
			gas.CREATED_BY = self.props.user.name;
			gas.CREATED_DATE = self.dateTimeToMVC(new Date());
		} else {
			url = '/Home/Update';
			gas.CREATED_DATE = self.dateTimeToMVC(self.getDate(gas.CREATED_DATE));
			gas.MODIF_BY = self.props.user.name;
			gas.MODIF_DATE = self.dateTimeToMVC(new Date());
		}
		
		this.ajax({
			type: 'POST',
			url: this.getConfig().host + url,
			overlay: true,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, entity: 'DEMURRAGE.DEM_GASES', data: gas }
		}).done(function (data) {
			if (data.Success) {
				var gasId = self.props.params.gasId || data.ID;
				var verb = self.props.params.gasId ? 'updated' : 'inserted';
				self.props.parent.showConfirmation(() => {
					return (<>
						Gas <Link to={'/HeLAD/Gases/' + gasId}>{gasId}</Link> {verb}.
					</>);
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Gas {this.state.gas.GAS_ID}&nbsp;&nbsp;
							{this.state.editable ? <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }} onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} onClick={() => this.mergeState({ editable: true })} />}				  
						  </div>
					  </Col>
					</Row>
					<Row>
					  <Col>
						<ChemEdit parent={this} columns={gasColumns} data={this.state.gas} user={this.props.user} renderKey={this.state.renderKey} 
						   onChange={(accessor, value) => this.onChange(accessor, value)} editable={this.state.editable} />
					  </Col>
					</Row>
					<Row style={{ paddingTop: 5 }}>
					  <Col>
						{this.state.editable && <Button id="save" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmit(event)}>Save</Button>}
						{this.state.editable && this.props.params.gasId && <Button id="delete" variant="warning" type="button" className="float-end"
						  style={{ marginRight: '20px' }} onClick={(event) => this.deleteGas(event)}>Delete</Button>} 
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const gasColumns = [
	{ Header: 'Name (Part Number)', accessor: 'GAS_NAME', row: 0, col: 0 },
	{ Header: 'Size', accessor: 'CYL_SIZE', row: 0, col: 1 },
	{ Header: 'Description', accessor: 'DESCRIPT', row: 1, col: 0 },
	{ Header: 'Price $', accessor: 'GAS_DEFAULT_PRICE', row: 1, col: 1 },
	{ Header: 'Vendor Price $', accessor: 'VENDOR_PRICE', row: 2, col: 0 },
	{ Header: 'Quote Date', accessor: 'QUOTE_DATE', type: 'date', row: 2, col: 1 },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 3, col: 0 },
	{ Header: 'Praxair Gas', accessor: 'PRAXAIR_FLAG', type: 'checkbox', row: 3, col: 1 },
	{ Header: 'Created', accessor: 'CREATED', row: 4, col: 0, editable: false },
	{ Header: 'Modified', accessor: 'MODIFIED', row: 4, col: 1, editable: false }
];

export default withRouter(Gas);
